/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.crm.usages.rpc.CrmUsagesServiceV3
 */

export const getAllDependenciesForAssetNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllDependenciesForAssetNode',
  auth: 'app',
  fingerprint: 'JFo6ZslgwDTwgEocFkenC0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllDependenciesOfTypeForAssetNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllDependenciesOfTypeForAssetNode',
  auth: 'app',
  fingerprint: 'ZZhz54oJ-9DwgEocFkenC0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getTotalAssetCountForDependencyNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getTotalAssetCountForDependencyNode',
  auth: 'app',
  fingerprint: 'KtpNu20P0da949g-TM8hHkEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDistinctDependencyNamesOfTypeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getDistinctDependencyNamesOfType',
  auth: 'app',
  fingerprint: '9FPOnSqQJHejn0ciN1kd70Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStrongUsagesForDependencyNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getStrongUsagesForDependencyNode',
  auth: 'app',
  fingerprint: 'PuVRU-bt8GBXm9aCnXpsqUEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllAssetsForDependencyNodePrefixRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllAssetsForDependencyNodePrefix',
  auth: 'app',
  fingerprint: 'X3B01rYWRTbhSCZfCea_CkEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllDependenciesForAssetNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllDependenciesForAssetNodes',
  auth: 'app',
  fingerprint: 'JWfxRdjIivLwgEocFkenC0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllDependenciesOfTypeForAssetNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllDependenciesOfTypeForAssetNodes',
  auth: 'app',
  fingerprint: '8VqFGqRzoDzwgEocFkenC0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllDependenciesWithLabelsForAssetNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAllDependenciesWithLabelsForAssetNodes',
  auth: 'app',
  fingerprint: 'La9bxHX6XJ6JRmy0VZcN3EEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRecentAssetsOfTypesForDependencyNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getRecentAssetsOfTypesForDependencyNodes',
  auth: 'app',
  fingerprint: 'ahGQtmyU0SGlvU30c03OyUEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssetCountsByTypeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAssetCountsByType',
  auth: 'app',
  fingerprint: 'RS-TBUpKzv0eDQaBKeoNK0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssetCountsByTypeForObjectRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAssetCountsByTypeForObject',
  auth: 'app',
  fingerprint: 'fuF0vj2JcAYeDQaBKeoNK0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAssetCountsByObjectTypeIdForDependencyAndAssetTypesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getAssetCountsByObjectTypeIdForDependencyAndAssetTypes',
  auth: 'app',
  fingerprint: 'cMUqK8o0CNYeDQaBKeoNK0Eww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageOfAssetsForDependencyNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getPageOfAssetsForDependencyNode',
  auth: 'app',
  fingerprint: '3xMlpcdRvHrg5rYc24c3UEEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageOfAssetsForDependencyNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getPageOfAssetsForDependencyNodes',
  auth: 'app',
  fingerprint: 'ds5xhiT4SbPg5rYc24c3UEEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUsagesForDependencyAndAssetTypesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getUsagesForDependencyAndAssetTypes',
  auth: 'app',
  fingerprint: 'CpdYAYBbI6Hg5rYc24c3UEEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageOfAssetsOfTypesForDependencyNodeRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getPageOfAssetsOfTypesForDependencyNode',
  auth: 'app',
  fingerprint: 'xDkW15318ujg5rYc24c3UEEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPageOfAssetsOfTypesForDependencyNodesRpc = {
  serviceName: 'com.hubspot.crm.usages.rpc.CrmUsagesServiceV3',
  rpcName: 'getPageOfAssetsOfTypesForDependencyNodes',
  auth: 'app',
  fingerprint: 'cm92pjc2oMHg5rYc24c3UEEww-fKekP1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};